import React, { useEffect } from 'react';
import { Route, Redirect } from "react-router-dom";
import CheckUserProvider from '../AllHooks/CheckUserProvider';


function AuthenticateUser({ component: Component, ...rest }) {
    const { userData } = CheckUserProvider();

    return (
        <Route {...rest} render={(props) => {
            if (!!userData) {
                return <Component {...props} />
            } else {
                return <Redirect to="/" />
            }
        }} />
    )
};

export default AuthenticateUser;
